class SchemaX {

  /**
   * 
   * @param {import("./Filterizo/__typedef").filterSchema} schema 
   * @returns 
   */
  static Filterizo(schema){
    return schema;
  }

  /**
   * 
   * @param {import("./Gridizo/__typedef").gridizoSchema} schema 
   * @returns 
   */
  static Gridizo(schema){
    return schema;
  }

}

export default SchemaX;